import { ensureTypeInfo } from './NeoTypeInfo';
/** ModelBase decorator
 * Intercepts the construction of objects to call SetupModel.
 */
export default function NeoModel(target) {
    var originalConstructor = target;
    // Ensure neo info is set
    var ctor = originalConstructor;
    // Call this in case no property decorators were added
    ensureTypeInfo(ctor);
    var newConstructor = ctor.neo.getOverrideConstructor();
    return newConstructor;
}
